import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/shijisun/edu/projects/imui/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Form, FormRow, Label } from './index';
import Button from '../button/index';
import { Radio, RadioGroup } from '../radio/index';
import Input from '../input/index';
import { CheckGroup } from '../checkbox/index';
import Checkbox from '../checkbox/index';
import Datepicker from '../datepicker/index';
import Validator from '../validator/index';
import Dropdown from '../dropdown/index';
import { Playground, Props } from 'docz';
import './style/index.scss';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "form"
    }}>{`Form`}</h1>

    <h2 {...{
      "id": "props--methods"
    }}>{`Props & Methods`}</h2>
    <h3 {...{
      "id": "form-1"
    }}>{`Form`}</h3>
    <Props of={Form} mdxType="Props" />
    <h3 {...{
      "id": "formrow"
    }}>{`FormRow`}</h3>
    <Props of={FormRow} mdxType="Props" />
    <h3 {...{
      "id": "label"
    }}>{`Label`}</h3>
    <Props of={Label} mdxType="Props" />
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic Usage`}</h2>
    <Playground __position={3} __code={'() => {\n  const options = [\n    {\n      label: \'班级通收费\',\n      id: 0,\n    },\n    {\n      label: \'班级1\',\n      id: 1,\n    },\n    {\n      label: \'班级2\',\n      id: 2,\n    },\n  ]\n  return (\n    <Form>\n      <FormRow>\n        <Label required help=\"//ke.qq.com\">\n          课程名称\n        </Label>\n        <Input />\n      </FormRow>\n      <FormRow>\n        <Label required help=\"//ke.qq.com\">\n          是否收费\n        </Label>\n        <RadioGroup>\n          <Radio value={0}>免费</Radio>\n          <Radio value={1}>付费</Radio>\n        </RadioGroup>\n      </FormRow>\n      <FormRow>\n        <Label required help=\"//ke.qq.com\">\n          上架IOS\n        </Label>\n        <RadioGroup inline={false}>\n          <Radio value={0}>是</Radio>\n          <Radio value={1}>否</Radio>\n        </RadioGroup>\n      </FormRow>\n      <FormRow>\n        <Label required help=\"//ke.qq.com\">\n          收费\n        </Label>\n        <CheckGroup options={options} />\n      </FormRow>\n      <FormRow>\n        <Label required help=\"//ke.qq.com\">\n          垂直的收费\n        </Label>\n        <CheckGroup options={options} inline={false} />\n      </FormRow>\n      <FormRow>\n        <Label required>报名截止时间</Label>\n        <Datepicker />\n      </FormRow>\n    </Form>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Form,
      FormRow,
      Label,
      Button,
      Radio,
      RadioGroup,
      Input,
      CheckGroup,
      Checkbox,
      Datepicker,
      Validator,
      Dropdown,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        const options = [{
          label: '班级通收费',
          id: 0
        }, {
          label: '班级1',
          id: 1
        }, {
          label: '班级2',
          id: 2
        }];
        return <Form mdxType="Form">
            <FormRow mdxType="FormRow">
              <Label required help="//ke.qq.com" mdxType="Label">课程名称</Label>
              <Input mdxType="Input" />
            </FormRow>
            <FormRow mdxType="FormRow">
              <Label required help="//ke.qq.com" mdxType="Label">是否收费</Label>
              <RadioGroup mdxType="RadioGroup">
                <Radio value={0} mdxType="Radio">免费</Radio>
                <Radio value={1} mdxType="Radio">付费</Radio>
              </RadioGroup>
            </FormRow>
            <FormRow mdxType="FormRow">
              <Label required help="//ke.qq.com" mdxType="Label">上架IOS</Label>
              <RadioGroup inline={false} mdxType="RadioGroup">
                <Radio value={0} mdxType="Radio">是</Radio>
                <Radio value={1} mdxType="Radio">否</Radio>
              </RadioGroup>
            </FormRow>
            <FormRow mdxType="FormRow">
              <Label required help="//ke.qq.com" mdxType="Label">收费</Label>
              <CheckGroup options={options} mdxType="CheckGroup" />
            </FormRow>
            <FormRow mdxType="FormRow">
              <Label required help="//ke.qq.com" mdxType="Label">垂直的收费</Label>
              <CheckGroup options={options} inline={false} mdxType="CheckGroup" />
            </FormRow>
            <FormRow mdxType="FormRow">
              <Label required mdxType="Label">报名截止时间</Label>
              <Datepicker mdxType="Datepicker" />
            </FormRow>
          </Form>;
      }}
    </Playground>
    <h2 {...{
      "id": "non-horizontal"
    }}>{`Non-horizontal`}</h2>
    <Playground __position={4} __code={'<Form horizontal={false}>\n  <FormRow>\n    <Label required>课程名称</Label>\n    <Input style={{ width: 165 }} />\n  </FormRow>\n  <FormRow>\n    <Label required>老师名称</Label>\n    <Input style={{ width: 165 }} />\n  </FormRow>\n  <FormRow>\n    <Label required>开始时间</Label>\n    <Datepicker />\n  </FormRow>\n</Form>'} __scope={{
      props,
      DefaultLayout,
      Form,
      FormRow,
      Label,
      Button,
      Radio,
      RadioGroup,
      Input,
      CheckGroup,
      Checkbox,
      Datepicker,
      Validator,
      Dropdown,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      <Form horizontal={false} mdxType="Form">
            <FormRow mdxType="FormRow">
              <Label required mdxType="Label">课程名称</Label>
              <Input style={{
            width: 165
          }} mdxType="Input" />
            </FormRow>
            <FormRow mdxType="FormRow">
              <Label required mdxType="Label">老师名称</Label>
              <Input style={{
            width: 165
          }} mdxType="Input" />
            </FormRow>
            <FormRow mdxType="FormRow">
              <Label required mdxType="Label">开始时间</Label>
              <Datepicker mdxType="Datepicker" />
            </FormRow>
          </Form>
    </Playground>
    <h2 {...{
      "id": "inline--horizontal"
    }}>{`Inline & Horizontal`}</h2>
    <Playground __position={5} __code={'<Form inline>\n  <FormRow>\n    <Label required>课程名称</Label>\n    <Input style={{ width: 165 }} />\n  </FormRow>\n  <FormRow>\n    <Label required>老师名称</Label>\n    <Input style={{ width: 165 }} />\n  </FormRow>\n  <FormRow>\n    <Label required>开始时间</Label>\n    <Datepicker />\n  </FormRow>\n</Form>'} __scope={{
      props,
      DefaultLayout,
      Form,
      FormRow,
      Label,
      Button,
      Radio,
      RadioGroup,
      Input,
      CheckGroup,
      Checkbox,
      Datepicker,
      Validator,
      Dropdown,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Form inline mdxType="Form">
            <FormRow mdxType="FormRow">
              <Label required mdxType="Label">课程名称</Label>
              <Input style={{
            width: 165
          }} mdxType="Input" />
            </FormRow>
            <FormRow mdxType="FormRow">
              <Label required mdxType="Label">老师名称</Label>
              <Input style={{
            width: 165
          }} mdxType="Input" />
            </FormRow>
            <FormRow mdxType="FormRow">
              <Label required mdxType="Label">开始时间</Label>
              <Datepicker mdxType="Datepicker" />
            </FormRow>
          </Form>
    </Playground>
    <h2 {...{
      "id": "inline--non-horizontal"
    }}>{`Inline & Non-horizontal`}</h2>
    <Playground __position={6} __code={'<Form inline horizontal={false}>\n  <FormRow>\n    <Label required>课程名称</Label>\n    <Input style={{ width: 165 }} />\n  </FormRow>\n  <FormRow>\n    <Label required>老师名称</Label>\n    <Input style={{ width: 165 }} />\n  </FormRow>\n  <FormRow>\n    <Label required>开始时间</Label>\n    <Datepicker />\n  </FormRow>\n</Form>'} __scope={{
      props,
      DefaultLayout,
      Form,
      FormRow,
      Label,
      Button,
      Radio,
      RadioGroup,
      Input,
      CheckGroup,
      Checkbox,
      Datepicker,
      Validator,
      Dropdown,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Form inline horizontal={false} mdxType="Form">
        <FormRow mdxType="FormRow">
            <Label required mdxType="Label">课程名称</Label>
            <Input style={{
            width: 165
          }} mdxType="Input" />
        </FormRow>
        <FormRow mdxType="FormRow">
            <Label required mdxType="Label">老师名称</Label>
            <Input style={{
            width: 165
          }} mdxType="Input" />
        </FormRow>
        <FormRow mdxType="FormRow">
            <Label required mdxType="Label">开始时间</Label>
            <Datepicker mdxType="Datepicker" />
        </FormRow>
    </Form>
    </Playground>
    <h2 {...{
      "id": "work-with-validator"
    }}>{`Work with Validator`}</h2>
    <Playground __position={7} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.state = {\n        disabled: true,\n      }\n      this.onValid = this.onValid.bind(this)\n      this.onInValid = this.onInValid.bind(this)\n      this.checkers = {\n        same: (val, callback) => {\n          const password = this.password.getValue()\n          callback({\n            isValid: password === val,\n            msg: \'密码不一致\',\n          })\n        },\n      }\n    }\n    onValid() {\n      this.setState({ disabled: false })\n    }\n    onInValid() {\n      this.setState({ disabled: true })\n    }\n    render() {\n      return (\n        <Form>\n          <Validator\n            checkers={this.checkers}\n            onValid={this.onValid}\n            onInValid={this.onInValid}\n          >\n            <FormRow>\n              <Label required>邮箱</Label>\n              <Input\n                name=\"email\"\n                data-required\n                data-patterns={[\n                  {\n                    key: \'email\',\n                    msg: \'格式不正确\',\n                  },\n                ]}\n              />\n            </FormRow>\n            <FormRow>\n              <Label required>密码</Label>\n              <Input\n                name=\"password\"\n                type=\"password\"\n                ref={instance => {\n                  this.password = instance\n                }}\n                data-required\n                data-patterns={[\n                  {\n                    key: \'limit\',\n                    msg: \'密码长度应在6-10位\',\n                    limit: {\n                      min: 6,\n                      max: 10,\n                    },\n                  },\n                ]}\n              />\n            </FormRow>\n            <FormRow>\n              <Label required>确认密码</Label>\n              <Input\n                name=\"c-password\"\n                type=\"password\"\n                data-required\n                data-patterns={[\n                  {\n                    key: \'limit\',\n                    msg: \'密码长度应在6-10位\',\n                    limit: {\n                      min: 6,\n                      max: 10,\n                    },\n                  },\n                  {\n                    key: \'same\',\n                  },\n                ]}\n              />\n            </FormRow>\n            <FormRow>\n              <Label>个性签名</Label>\n              <Input\n                name=\"sign\"\n                type=\"textarea\"\n                data-patterns={[\n                  {\n                    key: \'limit\',\n                    msg: \'100个字以内\',\n                    min: 1,\n                    max: 100,\n                  },\n                ]}\n              />\n            </FormRow>\n          </Validator>\n          <Button\n            type=\"button\"\n            style={{ marginLeft: 120 }}\n            disabled={this.state.disabled}\n          >\n            注册\n          </Button>\n        </Form>\n      )\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Form,
      FormRow,
      Label,
      Button,
      Radio,
      RadioGroup,
      Input,
      CheckGroup,
      Checkbox,
      Datepicker,
      Validator,
      Dropdown,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.state = {
              disabled: true
            };
            this.onValid = this.onValid.bind(this);
            this.onInValid = this.onInValid.bind(this);
            this.checkers = {
              same: (val, callback) => {
                const password = this.password.getValue();
                callback({
                  isValid: password === val,
                  msg: '密码不一致'
                });
              }
            };
          }

          onValid() {
            this.setState({
              disabled: false
            });
          }

          onInValid() {
            this.setState({
              disabled: true
            });
          }

          render() {
            return <Form mdxType="Form">
                <Validator checkers={this.checkers} onValid={this.onValid} onInValid={this.onInValid} mdxType="Validator">
                <FormRow mdxType="FormRow">
                    <Label required mdxType="Label">邮箱</Label>
                    <Input name="email" data-required data-patterns={[{
                    key: 'email',
                    msg: '格式不正确'
                  }]} mdxType="Input" />
                </FormRow>
                <FormRow mdxType="FormRow">
                    <Label required mdxType="Label">密码</Label>
                    <Input name="password" type="password" ref={instance => {
                    this.password = instance;
                  }} data-required data-patterns={[{
                    key: 'limit',
                    msg: '密码长度应在6-10位',
                    limit: {
                      min: 6,
                      max: 10
                    }
                  }]} mdxType="Input" />
                </FormRow>
                <FormRow mdxType="FormRow">
                    <Label required mdxType="Label">确认密码</Label>
                    <Input name="c-password" type="password" data-required data-patterns={[{
                    key: 'limit',
                    msg: '密码长度应在6-10位',
                    limit: {
                      min: 6,
                      max: 10
                    }
                  }, {
                    key: 'same'
                  }]} mdxType="Input" />
                </FormRow>
                <FormRow mdxType="FormRow">
                    <Label mdxType="Label">个性签名</Label>
                    <Input name="sign" type="textarea" data-patterns={[{
                    key: 'limit',
                    msg: '100个字以内',
                    min: 1,
                    max: 100
                  }]} mdxType="Input" />
                </FormRow>
                </Validator>
                <Button type="button" style={{
                marginLeft: 120
              }} disabled={this.state.disabled} mdxType="Button">
                注册
                </Button>
            </Form>;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>
    <h2 {...{
      "id": "form-instances-api"
    }}>{`Form Instances API`}</h2>
    <pre><code parentName="pre" {...{}}>{`注意：使用Form API时，表单组件使用Form命名空间下的组件，见下面一个demo
`}</code></pre>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`API`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`说明`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`类型`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`getValues`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`获取此Form下的所有带name的表单组件的值`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Function(): `}<inlineCode parentName="td">{`object {name -> value}`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`setValues`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`设置此Form下的所有带name的表单组件的值`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Function(): `}<inlineCode parentName="td">{`object {name -> value}`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`getFieldValue(name)`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`获取对应表单的值`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Function(name: `}<inlineCode parentName="td">{`string`}</inlineCode>{`): `}<inlineCode parentName="td">{`any`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`setFieldValue(name, value)`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`设置对应表单的值`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Function(name: `}<inlineCode parentName="td">{`string`}</inlineCode>{`, value: `}<inlineCode parentName="td">{`any`}</inlineCode>{`): `}<inlineCode parentName="td">{`bool`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <pre><code parentName="pre" {...{}}>{`几点说明：
* Form组件主要解决表单布局的问题，如果有什么新的建议或者想法提issue出来哈！
* Form组件为其所有子元素提供了一个context，\`this.context.form\`就是Form组件实例
* Form布局实现有更改\`im-form--{修饰}\`类下的表单组件如\`im-checkgroup\`，\`im-radio-group\`的样式，如果出现布局问题可以自行更改
`}</code></pre>
    <Playground __position={8} __code={'() => {\n  class Example extends React.Component {\n    constructor(props) {\n      super(props)\n      this.state = {\n        values: \'\',\n      }\n      this.getFormValues = this.getFormValues.bind(this)\n      this.setFormValues = this.setFormValues.bind(this)\n      this.editingValues = this.editingValues.bind(this)\n    }\n    getFormValues() {\n      const values = this.refs.myForm.getValues()\n      this.setState({ values: JSON.stringify(values) })\n    }\n    setFormValues() {\n      const values = JSON.parse(this.state.values)\n      this.refs.myForm.setValues(values)\n    }\n    editingValues(values) {\n      this.setState({ values })\n    }\n    render() {\n      const checkOpts = [\n        {\n          label: \'默认选中且disabled\',\n          id: 1,\n          disabled: true,\n        },\n        {\n          label: \'默认待选中\',\n          id: 2,\n        },\n        {\n          label: <span>默认选中，带有自定义标签/元素的label</span>,\n          id: 3,\n        },\n      ]\n      return (\n        <Form ref=\"myForm\">\n          <FormRow>\n            <p>Form.Input</p>\n            <Input name=\"input\" style={{ width: 165 }} />\n          </FormRow>\n          <FormRow>\n            <p>Form.Datepicker</p>\n            <Datepicker name=\"datepicker\" />\n          </FormRow>\n          <FormRow>\n            <p>Form.Dropdown</p>\n            <Dropdown\n              name=\"dropdown\"\n              options={[{ value: \'A\' }, { value: \'B\' }, { value: \'C\' }]}\n              style={{ width: \'200px\' }}\n            />\n          </FormRow>\n          <FormRow>\n            <p>Form.Checkbox</p>\n            <Checkbox name=\"checkbox\" checked />\n          </FormRow>\n          <FormRow>\n            <p>Form.CheckGroup</p>\n            <CheckGroup\n              name=\"checkgroup\"\n              options={checkOpts}\n              value={[1, 3]}\n            />\n          </FormRow>\n          <FormRow>\n            <p>Form.RadioGroup</p>\n            <RadioGroup name=\"radiogroup\">\n              <Radio value={0}>免费</Radio>\n              <Radio value={1}>收费</Radio>\n            </RadioGroup>\n          </FormRow>\n          <Button type=\"button\" onClick={this.getFormValues}>\n            getValues\n          </Button>\n          <Button\n            type=\"button\"\n            style={{ marginLeft: 40 }}\n            onClick={this.setFormValues}\n          >\n            setValues\n          </Button>\n          <Input\n            placeholder=\"按钮点击结果展示\"\n            value={this.state.values}\n            onChange={this.editingValues}\n            style={{\n              display: \'block\',\n              marginTop: 20,\n              width: 400,\n            }}\n          />\n        </Form>\n      )\n    }\n  }\n  return <Example />\n}'} __scope={{
      props,
      DefaultLayout,
      Form,
      FormRow,
      Label,
      Button,
      Radio,
      RadioGroup,
      Input,
      CheckGroup,
      Checkbox,
      Datepicker,
      Validator,
      Dropdown,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        class Example extends React.Component {
          constructor(props) {
            super(props);
            this.state = {
              values: ''
            };
            this.getFormValues = this.getFormValues.bind(this);
            this.setFormValues = this.setFormValues.bind(this);
            this.editingValues = this.editingValues.bind(this);
          }

          getFormValues() {
            const values = this.refs.myForm.getValues();
            this.setState({
              values: JSON.stringify(values)
            });
          }

          setFormValues() {
            const values = JSON.parse(this.state.values);
            this.refs.myForm.setValues(values);
          }

          editingValues(values) {
            this.setState({
              values
            });
          }

          render() {
            const checkOpts = [{
              label: '默认选中且disabled',
              id: 1,
              disabled: true
            }, {
              label: '默认待选中',
              id: 2
            }, {
              label: <span>默认选中，带有自定义标签/元素的label</span>,
              id: 3
            }];
            return <Form ref="myForm" mdxType="Form">
            <FormRow mdxType="FormRow">
            <p>Form.Input</p>
            <Input name="input" style={{
                  width: 165
                }} mdxType="Input" />
            </FormRow>
            <FormRow mdxType="FormRow">
            <p>Form.Datepicker</p>
            <Datepicker name="datepicker" mdxType="Datepicker" />
            </FormRow>
            <FormRow mdxType="FormRow">
            <p>Form.Dropdown</p>
            <Dropdown name="dropdown" options={[{
                  value: 'A'
                }, {
                  value: 'B'
                }, {
                  value: 'C'
                }]} style={{
                  width: '200px'
                }} mdxType="Dropdown" />
            </FormRow>
            <FormRow mdxType="FormRow">
            <p>Form.Checkbox</p>
            <Checkbox name="checkbox" checked mdxType="Checkbox" />
            </FormRow>
            <FormRow mdxType="FormRow">
            <p>Form.CheckGroup</p>
            <CheckGroup name="checkgroup" options={checkOpts} value={[1, 3]} mdxType="CheckGroup" />
            </FormRow>
            <FormRow mdxType="FormRow">
            <p>Form.RadioGroup</p>
            <RadioGroup name="radiogroup" mdxType="RadioGroup">
                <Radio value={0} mdxType="Radio">免费</Radio>
                <Radio value={1} mdxType="Radio">收费</Radio>
            </RadioGroup>
            </FormRow>
            <Button type="button" onClick={this.getFormValues} mdxType="Button">getValues</Button>
            <Button type="button" style={{
                marginLeft: 40
              }} onClick={this.setFormValues} mdxType="Button">setValues</Button>
            <Input placeholder="按钮点击结果展示" value={this.state.values} onChange={this.editingValues} style={{
                display: 'block',
                marginTop: 20,
                width: 400
              }} mdxType="Input" />
        </Form>;
          }

        }

        return <Example mdxType="Example" />;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      